'use client';

import { c as _c } from "react/compiler-runtime";
import type { JSX, ReactNode } from 'react';
import './morfi-product-button.css';
const DUST_PARTICLE_KEYS = ['dust-a', 'dust-b', 'dust-c', 'dust-d', 'dust-e', 'dust-f', 'dust-g', 'dust-h', 'dust-i', 'dust-j'] as const;
export function MorfiProductButtonChrome(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span aria-hidden="true" className="morfi-product-button__beam morfi-product-button__beam--glow" />;
    t2 = <span aria-hidden="true" className="morfi-product-button__beam" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span aria-hidden="true" className="morfi-product-button__dust">{DUST_PARTICLE_KEYS.map(_temp)}</span>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <>{t1}{t2}{t3}<span className="morfi-product-button__label">{children}</span></>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp(particleKey) {
  return <span key={particleKey} className="morfi-product-button__dust-particle" />;
}